import {Component, forwardRef, Injector, Input} from "@angular/core";
import {AbstractEditControlComponent} from "../../../entity/edit/edit-controls/abstract-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BooleanRadioEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-boolean-radio-edit-control",
    templateUrl: "boolean-radio-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class BooleanRadioEditControlComponent extends AbstractEditControlComponent {
    @Input() trueLabel: string = "wbo.common.label.enabled";
    @Input() falseLabel: string = "wbo.common.label.disabled";
    @Input() showTrueOption: boolean = true;
    @Input() showFalseOption: boolean = true;
    @Input() bordered: boolean = false;
    @Input() firstOption: boolean = true;

    constructor(injector: Injector) {
        super(injector);
    }
}
